// src/components/HealthDot.jsx
//
// Round status dot. Optional click hover affordance, identical visuals
// to the legacy monolith's HealthDot.

import React from "react";
import { HEALTH, T } from "../app/tokens.js";

export function HealthDot({ health, onClick, size = 14, noShadow = false }) {
  const healthInfo = health
    ? HEALTH[health]
    : { color: T.defaultDot, bg: T.defaultDotBg, ring: T.defaultDot };
  const outer = size * 2;
  return (
    <div
      onClick={onClick}
      title={health ? `Health: ${HEALTH[health]?.label}` : "No health data"}
      style={{
        width: outer,
        height: outer,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        cursor: onClick ? "pointer" : "default",
        flexShrink: 0,
        transition: "background 0.15s",
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.background = healthInfo.bg || T.defaultDotBg;
          if (e.currentTarget.firstChild) {
            e.currentTarget.firstChild.style.transform = "scale(1.15)";
          }
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        if (e.currentTarget.firstChild) {
          e.currentTarget.firstChild.style.transform = "scale(1)";
        }
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: healthInfo.color,
          ...(noShadow ? {} : { boxShadow: `0 0 0 3px ${healthInfo.ring || healthInfo.color}` }),
          flexShrink: 0,
          transition: "transform 0.15s",
        }}
      />
    </div>
  );
}
